import { gql } from '@apollo/client';

// NOTE: we call them classes in the front end after a change but the backend and databse still use the term courses

export const GET_CLASSES = gql`
query Classes($search: String, $filters: String) {
  classes(search: $search, filters: $filters) {
    id
    name
    SKU
    program
    classLabel
    level
    timesOfWeek
    teachers {
        id
        name
    }
    courseParticipantCount
    archivedAt
    isHistoric
  }
}`;
